import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { CategoriaDTO } from "../../interfaces/categoria.interface";

import { environment as ENV } from "environments/environment";
import { HttpClient } from "@angular/common/http";

import { PrecioDTO } from "../../interfaces/precio.interface";
import { ServicioDTO } from "../../interfaces/servicio.interface";
import { NuevoServicioDTO } from "../../models/servicio.model";

const API = "catalogo/";
@Injectable({
    providedIn: "root",
})
export class CatalogoService {
    public onServiciosChanged: Subject<ServicioDTO[]> = new Subject();
    public onCategoriaChanged: Subject<boolean> = new Subject();
    constructor(private http: HttpClient) {}

    fetchCatalogoServicios(): Observable<CategoriaDTO[]> {
        return this.http.get<CategoriaDTO[]>(`${ENV.apiUrl}${API}`);
    }

    fetchServiciosPorGrupo(idGrupo: number): Observable<ServicioDTO[]> {
        return this.http.get<ServicioDTO[]>(`${ENV.apiUrl}${API}${idGrupo}`);
    }

    fetchPrecioServicio(
        idServicio: number,
        idComuna: number
    ): Observable<PrecioDTO> {
        return this.http.get<PrecioDTO>(
            `${ENV.apiUrl}${API}servicio/${idServicio}/precio?idComuna=${idComuna}`
        );
    }

    getGrupo(categorias: CategoriaDTO[], idGrupo: number): CategoriaDTO {
        //console.log("grupo", idGrupo);
        let cat: CategoriaDTO;

        categorias.forEach((categoria) =>
            categoria.grupos.filter((grupo) => {
                if (grupo.id === idGrupo) {
                    cat = categoria;
                }
            })
        );
        return cat;
    }

    getTodosGrupos(categorias: CategoriaDTO[]): CategoriaDTO[] {
        const grupos: CategoriaDTO[] = [];

        categorias.forEach((categoria) =>
            categoria.grupos.forEach((grupo) => {
                //console.log(grupo);
                grupos.push(grupo);
            })
        );
        return grupos;
    }

    fetchServicios(idGrupo: number): Observable<ServicioDTO[]> {
        return this.http.get<ServicioDTO[]>(`${ENV.apiUrl}${API}${idGrupo}`);
    }

    savePrecioServicios(
        idServicio: number,
        desde: number,
        hasta: number
    ): Observable<ServicioDTO[]> {
        return this.http.put<any>(
            `${ENV.apiUrl}${API}servicio/${idServicio}/precio?valorDesde=${desde}&valorHasta=${hasta}`,
            null
        );
    }

    saveServicio(idGrupo: number, servicio: NuevoServicioDTO) {
        return this.http.post<any>(
            `${ENV.apiUrl}${API}${idGrupo}/servicio`,
            servicio
        );
    }

    deleteServicio(idServicio:number):Observable<any>{
        return this.http.delete<any>(`${ENV.apiUrl}${API}servicio/${idServicio}`);
    }
}
